export const kitchens = {
  type: 'Kitchens',
  arType: 'مطابخ',
  assets: [
    {
      id: 1,
      img: 'https://storage.googleapis.com/door-assets/site/kitchens/IMG_7156_web.jpg',
      title: '',
    },
    {
      id: 2,
      img: 'https://storage.googleapis.com/door-assets/site/kitchens/IMG_5594_web.jpg',
      title: '',
    },
    {
      id: 3,
      img: 'https://storage.googleapis.com/door-assets/site/kitchens/IMG_5598_web.jpg',
      title: '',
    },
    {
      id: 4,
      img: 'https://storage.googleapis.com/door-assets/site/kitchens/IMG_0012.jpg',
      title: '',
    },
    {
      id: 5,
      img: 'https://storage.googleapis.com/door-assets/site/kitchens/IMG_0605_web.jpg',
      title: '',
    },
    {
      id: 6,
      img: 'https://storage.googleapis.com/door-assets/site/kitchens/IMG_5591_web.jpg',
      title: '',
    },
    {
      id: 7,
      img: 'https://storage.googleapis.com/door-assets/site/kitchens/IMG_0011.jpg',
      title: '',
    },
    {
      id: 8,
      img: 'https://storage.googleapis.com/door-assets/site/kitchens/IMG_2131.jpg',
      title: '',
    },
    {
      id: 9,
      img: 'https://storage.googleapis.com/door-assets/site/kitchens/IMG_2744.jpg',
      title: '',
    },
    {
      id: 10,
      img: 'https://storage.googleapis.com/door-assets/site/kitchens/IMG_2747.jpg',
      title: '',
    },
    {
      id: 11,
      img: 'https://storage.googleapis.com/door-assets/site/kitchens/IMG_2751.jpg',
      title: '',
    },
  ]
};
